import React from 'react';

import { LeadModel } from '@/typings/models/Lead';
import TipTapEditableField from '@/components/Lead/TipTapEditableField';
import styles from './index.less';

const LeadNote = ({
  lead,
  showFull,
  isCustomer,
  readonly,
}: {
  lead: LeadModel;
  showFull?: boolean;
  isCustomer?: boolean;
  readonly?: boolean;
}) => {
  const isTable = !showFull;
  const notes = lead?.customer?.notes || ' - ';
  const content = (
    <TipTapEditableField
      isCustomer={isCustomer}
      isTable={isTable}
      lead={lead}
      property={'customer.notes'}
      readonly={readonly}
    >
      {notes}
    </TipTapEditableField>
  );

  if (isTable) return <div className={styles.leadTableNotes}>
    {content}
  </div>
  return content;
}

export default LeadNote
